export enum EnumBooleanStringified {
  TRUE = "true",
  FALSE = "false",
}
